import React, { useState } from 'react'

import { LeadWelcomeAccountsAnalyticsDeviceKey } from './LeadWelcomeAccountsAnalyticsDeviceKey'
import { LeadWelcomeAccountsAnalyticsIPAddress } from './LeadWelcomeAccountsAnalyticsIPAddress'
import {
  isDeviceKeyAnalytics,
  isIPAddressAnalytics,
  LeadWelcomeAccountsAnalyticsNavigation,
  LeadWelcomeAccountsAnalyticsTab,
} from './LeadWelcomeAccountsAnalyticsNavigation'

interface WelcomeTradingAccount {
  id: string
  name: string
}

interface OuterProps {
  data: WelcomeTradingAccount
}

export const LeadWelcomeAccountsAnalytics: React.FC<OuterProps> = (props) => {
  const { data } = props

  const [keyToChange, setKeyToChange] = useState<LeadWelcomeAccountsAnalyticsTab>(
    LeadWelcomeAccountsAnalyticsTab.IPAddressAnalytics
  )

  const handleNavigationChange = (value: LeadWelcomeAccountsAnalyticsTab) => {
    setKeyToChange(value)
  }

  return (
    <React.Fragment>
      <LeadWelcomeAccountsAnalyticsNavigation
        activeKey={keyToChange}
        onChange={handleNavigationChange}
      />
      {isIPAddressAnalytics(keyToChange) && <LeadWelcomeAccountsAnalyticsIPAddress data={data} />}
      {isDeviceKeyAnalytics(keyToChange) && <LeadWelcomeAccountsAnalyticsDeviceKey data={data} />}
    </React.Fragment>
  )
}
